import { render, staticRenderFns } from "./upVersionAlert.vue?vue&type=template&id=accfca7e&scoped=true&"
import script from "./upVersionAlert.vue?vue&type=script&lang=js&"
export * from "./upVersionAlert.vue?vue&type=script&lang=js&"
import style0 from "./upVersionAlert.vue?vue&type=style&index=0&id=accfca7e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accfca7e",
  null
  
)

export default component.exports